import { render } from "./ViewAllCouponsPage.vue?vue&type=template&id=24ae11d1&scoped=true"
import script from "./ViewAllCouponsPage.vue?vue&type=script&lang=js"
export * from "./ViewAllCouponsPage.vue?vue&type=script&lang=js"

import "./ViewAllCouponsPage.vue?vue&type=style&index=0&id=24ae11d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ae11d1"]])

export default __exports__